export const setData = (dispatch, type, value) => {
    if (value.data[0].kod === 200) {
        dispatch({
            type: type,
            value: value.data[1]
        });
    }
};

export const expandSelectableObject = (cars) => {
    return cars.map(car => {
        return {
            ...car,
            selected: false
        };
    });
};

// todo usunąć gdy już będą zwracane wszystkie dane
export const setNotificationsData = (dispatch, type, value) => {

    if (value.data[0].kod === 200) {

        const tmp = {
            ...value.data[1],
            przekroczenie_granicy: {
                email: false,
                telefon: false
            }
        };

        if ('przekroczenie_granicy' in value.data[1]) {
            tmp.przekroczenie_granicy.email = value.data[1].przekroczenie_granicy.email;
            tmp.przekroczenie_granicy.telefon = value.data[1].przekroczenie_granicy.telefon;
        }

        dispatch({
            type: type,
            value: tmp
        });
    }
};

export const setGroupsData = (dispatch, type, value) => {

    if (value.data[0].kod === 200) {

        const tmp = [...value.data[1]].map(i => {
            if ('przekroczenie_granicy' in i) {
                return i;
            }

            return {...i, przekroczenie_granicy: false};
        });


        dispatch({
            type: type,
            value: tmp
        });
    }
};